import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import styles from './quotation.scss.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
/**
 * @returns blockquote component.
 *
 * @slot attribution
 * @slot content
 *
 */
export class Quotation extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * The type of Quotation.
         */
        this.background = 'primary';
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<figure><cipublic-icon role="img" name="chat-quote" aria-label="chat-quote" set="system"></cipublic-icon><blockquote><slot></slot></blockquote><figcaption><slot name="attribution"></slot></figcaption></figure>`;
    }
}
__decorate([
    property({ reflect: true })
], Quotation.prototype, "background", void 0);
//# sourceMappingURL=quotation.js.map